import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { LogoEmblem } from "./LogoMark";
import { useCart } from "@/context/CartContext";

const NAV_LEFT = [
  { to: "/shop", label: "Shop" },
  { to: "/the-craft", label: "The Craft" },
];
const NAV_RIGHT = [
  { to: "/our-story", label: "About" },
  { to: "/contact-us", label: "Contact" },
];

const Header = () => {
  const { setOpen, count } = useCart();
  const loc = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setMobileOpen(false), [loc.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-500 ${
        scrolled
          ? "bg-ground/95 backdrop-blur-[6px] hairline-b"
          : "bg-ground hairline-b"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24 py-5 md:py-6">
        <div className="hidden md:grid grid-cols-3 items-center">
          {/* left nav */}
          <nav className="flex items-center gap-10">
            {NAV_LEFT.map((n) => (
              <Link key={n.to} to={n.to} className="nav-item" data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, '-')}`}>
                {n.label}
              </Link>
            ))}
          </nav>
          {/* center emblem */}
          <div className="flex items-center justify-center">
            <Link to="/" aria-label="MELAVI — home" data-testid="logo-home-link">
              <LogoEmblem size={180} className="max-h-[76px] w-auto" />
            </Link>
          </div>
          {/* right nav */}
          <nav className="flex items-center gap-10 justify-end">
            {NAV_RIGHT.map((n) => (
              <Link key={n.to} to={n.to} className="nav-item" data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, '-')}`}>
                {n.label}
              </Link>
            ))}
            <button
              onClick={() => setOpen(true)}
              className="nav-item flex items-center gap-2"
              data-testid="cart-open-btn"
              aria-label="Open cart"
            >
              <span>Cart</span>
              <span className="inline-flex items-center justify-center w-5 h-5 hairline rounded-full text-[10px] tracking-normal">
                {count}
              </span>
            </button>
          </nav>
        </div>

        {/* mobile */}
        <div className="md:hidden flex items-center justify-between">
          <button
            className="nav-item"
            onClick={() => setMobileOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
          >
            {mobileOpen ? "Close" : "Menu"}
          </button>
          <Link to="/" aria-label="MELAVI — home" data-testid="logo-home-mobile-link">
            <LogoEmblem size={140} className="max-h-[56px] w-auto" />
          </Link>
          <button
            onClick={() => setOpen(true)}
            className="nav-item flex items-center gap-1"
            data-testid="cart-open-mobile-btn"
          >
            Cart <span className="ml-1 inline-flex items-center justify-center w-5 h-5 hairline rounded-full text-[10px]">{count}</span>
          </button>
        </div>
        {mobileOpen && (
          <nav className="md:hidden mt-6 flex flex-col gap-4 pb-4" data-testid="nav-mobile-menu">
            {[...NAV_LEFT, ...NAV_RIGHT].map((n) => (
              <Link key={n.to} to={n.to} className="nav-item" data-testid={`nav-mobile-${n.label.toLowerCase().replace(/\s/g, '-')}`}>
                {n.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
